module.exports = __webpack_public_path__ + "img/acaki18.10f9836d.jpg";